
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30884',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30884",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55451",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8422",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11875",
  "I18n": "static-7.1688",
  "quartz": "static-1.7554",
  "quartz-config": "static-1.1332",
  "quartz-core": "static-1.6773",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1007",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55438",
  "feedback-utils": "static-1.55442",
  "forms-embed-utils-lib": "static-1.4852",
  "forms-utils-lib": "static-1.13200",
  "foundations-assets": "static-1.5274",
  "foundations-components": "static-1.8613",
  "foundations-theming": "static-1.4864",
  "hub-http": "static-1.6596",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12182",
  "icons": "static-2.696",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4176",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17113",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5607",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.511",
  "tinymce-plugins": "static-1.58360",
  "transmute": "static-2.97",
  "ui-images": "static-2.1266",
  "UIComponents": "static-3.8821",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3831",
  "quartz-webpack": "static-1.3778",
  "foundations-theming-specialty": "static-1.2580",
  "property-description-translator": "static-1.4209",
  "HeadJS": "static-2.809",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3533",
  "msw": "static-1.39",
  "msw-config": "static-1.14",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4696",
  "jasmine-runner": "static-1.6834",
  "opentelemetry-fe-types": "static-1.171",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.895",
  "hubspotter-http": "static-1.4911",
  "mobile-manifest-mixins": "static-1.590",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.546",
  "quartz-auth": "static-1.1229",
  "quartz-head": "static-1.1219",
  "quartz-i18n": "static-1.1229",
  "quartz-routing": "static-1.984",
  "quartz-test": "static-1.1229",
  "quartz-tracking": "static-1.933",
  "trellis-components": "static-1.2882",
  "ui-fonts": "static-1.1137",
  "usage-tracker-container": "static-1.7688",
  "usage-tracker-core": "static-1.7548",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.275",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8568",
  "sanitize-text": "static-1.8544",
  "PatternValidationJS": "static-1.3275",
  "ReduxMessenger": "static-2.10757",
  "outpost": "static-1.4524",
  "rpc-client-utils": "static-1.5051",
  "sanitize": "static-1.4857",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4882",
  "floating-ui": "static-1.66",
  "hs-story-utils": "static-1.9810",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.86",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2863",
  "bend-plugin-foundations-theming": "static-1.3347",
  "foundations-theming-base": "static-1.3849",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.347",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9872",
  "atom": "static-1.5466",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8302",
  "ContentUtils": "static-1.69289",
  "data-token-picker": "static-1.16997",
  "file-manager-components": "static-1.24664",
  "FileManagerCore": "static-1.40163",
  "FileManagerLib": "static-1.40304",
  "frontend-preferences-client": "static-1.8307",
  "hub-http-contrib": "static-1.3412",
  "interframe": "static-3.5128",
  "layout-dnd-components": "static-1.13084",
  "layout-dnd-utils": "static-1.12059",
  "property-translator": "static-1.5766",
  "react-codemirror": "static-1.11027",
  "react-colorpicker": "static-2.10599",
  "reference-resolvers-lite": "static-1.8488",
  "rich-text-lib": "static-1.20423",
  "tinymce-data": "static-1.41331",
  "tinymce-themes": "static-1.57216",
  "ui-addon-emoji-picker": "static-1.10255",
  "ui-addon-sales-email": "static-1.5589",
  "ui-brand-identity-lib": "static-1.16726",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.90",
  "hub-http-shared-msw-handlers": "static-1.10750",
  "hubspotter-http-shared-msw-handlers": "static-1.10748",
  "usage-tracker-session-replay": "static-1.5384",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1363",
  "tanstack-virtual": "static-1.41",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.461",
  "chirp-fetch": "static-1.2286",
  "stylex-utils": "static-1.155",
  "chatspot-core": "static-1.23360",
  "copilot-toolkit": "static-1.11984",
  "customer-data-objects-ui-components": "static-1.13416",
  "data-fetching-client": "static-1.10033",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5146",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29449",
  "usage-tracker": "static-1.7698",
  "cms-field-types": "static-1.5197",
  "content-icons-ui": "static-1.2412",
  "integrations-lib": "static-1.17229",
  "customer-data-objects": "static-1.8077",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1939",
  "apollo-link-hub-http": "static-2.5013",
  "apollo-stack-hubspot": "static-3.97",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4530",
  "poll-commands": "static-1.3858",
  "ui-addon-iframeable": "static-1.9463",
  "video-components-external": "static-1.12284",
  "video-data-lib": "static-1.35942",
  "breeze-artifacts-sdk": "static-1.590",
  "audio-components": "static-1.6450",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29922",
  "FileManagerImages": "static-1.37815",
  "foundations-components-legacy": "static-1.1638",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.648",
  "ui-universal-auth": "static-1.9557",
  "urlinator": "static-1.4904",
  "video-components": "static-1.14286",
  "video-embed": "static-1.36776",
  "ts-schema": "static-1.4346",
  "ContentData": "static-1.69364",
  "layout-data-lib": "static-1.10384",
  "react-dnd-compat": "static-1.5000",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1932",
  "external-options-client-types": "static-1.4393",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7281",
  "hs-promise-utils": "static-1.5975",
  "inbound-db-properties-service-client": "static-1.4095",
  "NamespacedHubStyle": "static-2.9311",
  "growth-onboarding-confetti": "static-1.3450",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11535",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5823",
  "magpie-types": "static-1.5283",
  "simple-logging-lib": "static-1.3439",
  "avatar-components": "static-1.2868",
  "customer-data-ui-utilities": "static-1.10217",
  "growth-onboarding-feedback-components": "static-1.6971",
  "flux-actions": "static-1.377",
  "hubspot-apollo-client": "static-1.5261",
  "integrations-error-boundary-lib": "static-1.14644",
  "integrations-tracking-lib": "static-1.5997",
  "laboratory-lib": "static-3.7537",
  "native-integrations-shared-strings": "static-1.8150",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10657",
  "unified-auth": "static-1.1071",
  "breeze-engine-chat-components": "static-1.917",
  "breeze-engine-core": "static-1.1217",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1019",
  "navigation-messaging": "static-1.8304",
  "content-media-composition-data-lib": "static-1.13411",
  "content-media-compositions": "static-2.17418",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19514",
  "nudge-client-utils": "static-1.3264",
  "unified-auth-core-lib": "static-1.1353",
  "social-insights-client-types": "static-1.22776",
  "advanced-menus-core": "static-1.15680",
  "advanced-menus-lib": "static-1.12508",
  "ExportDialog": "static-6.10764",
  "ui-memberships-settings-lib": "static-1.34983",
  "conditional-properties-service-client": "static-1.4068",
  "crm-pipelines-api-client-types": "static-1.4398",
  "fdsr-migration-layer": "static-1.400",
  "framework-builder-read-service-client": "static-1.4273",
  "framework-data-schema-quick-fetch": "static-1.7186",
  "inbound-db-meta-service-client": "static-1.3724",
  "multi-currency-client-types": "static-1.3962",
  "persist-promise": "static-1.4089",
  "foundations-components-test-utils": "static-1.6096",
  "reactive-lib": "static-1.1107",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.720",
  "universal-page-editor-lib": "static-1.3396",
  "adobe-sign-auth-lib": "static-1.611",
  "ads-unified-auth-lib": "static-1.1649",
  "custom-vendor-connection-lib": "static-1.121",
  "google-sheets-integration-lib": "static-1.1174",
  "microsoft-drive-auth-lib": "static-1.326",
  "surveymonkey-integration-lib": "static-1.672",
  "slack-ui-library": "static-1.10783",
  "bend-plugin-pulse": "static-1.522",
  "event-emitter": "static-1.1345",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3021",
  "nudge-renderer-utils": "static-1.3340",
  "onboarding-tours": "static-1.17254",
  "whisper-core-api": "static-1.7477",
  "fsm": "static-1.4139",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15679",
  "simple-menus-lib": "static-1.17196",
  "settings-ui-lib": "static-1.12911",
  "crm-record-cards-service-types": "static-1.3821",
  "location-customization-utils-lib": "static-1.10254",
  "getting-started-shared-tasks": "static-1.19395",
  "growth-data-modal": "static-1.6002",
  "growth-onboarding-next-action-utils": "static-1.2831",
  "navigation-components": "static-1.18977",
  "onboarding-tours-client": "static-1.5469",
  "onboarding-tours-utils": "static-1.1321",
  "ui-shepherd-tracker": "static-1.8038",
  "user-context": "static-1.5473",
  "react-flip-move": "static-1.81",
  "onboarding-data-sync-lib": "static-1.2680",
  "growth-onboarding-next-action-components": "static-1.2859",
  "user-context-client": "static-1.4895",
  "nest": "static-1.621",
  "getting-started-shared-tasks-store": "static-1.18513",
  "InboxConnectUtils": "static-4.15693",
  "meetings-connect-utils-lib": "static-1.8000",
  "onboarding-scopes": "static-1.6839"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30884",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55451",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8422",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11875",
  "I18n": "/I18n/static-7.1688",
  "quartz": "/quartz/static-1.7554",
  "quartz-config": "/quartz-config/static-1.1332",
  "quartz-core": "/quartz-core/static-1.6773",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1007",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55438",
  "feedback-utils": "/feedback-utils/static-1.55442",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4852",
  "forms-utils-lib": "/forms-utils-lib/static-1.13200",
  "foundations-assets": "/foundations-assets/static-1.5274",
  "foundations-components": "/foundations-components/static-1.8613",
  "foundations-theming": "/foundations-theming/static-1.4864",
  "hub-http": "/hub-http/static-1.6596",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12182",
  "icons": "/icons/static-2.696",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4176",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17113",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5607",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "tinymce-plugins": "/tinymce-plugins/static-1.58360",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1266",
  "UIComponents": "/UIComponents/static-3.8821",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3831",
  "quartz-webpack": "/quartz-webpack/static-1.3778",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2580",
  "property-description-translator": "/property-description-translator/static-1.4209",
  "HeadJS": "/HeadJS/static-2.809",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3533",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.14",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4696",
  "jasmine-runner": "/jasmine-runner/static-1.6834",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.171",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hubspotter-http": "/hubspotter-http/static-1.4911",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.590",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.546",
  "quartz-auth": "/quartz-auth/static-1.1229",
  "quartz-head": "/quartz-head/static-1.1219",
  "quartz-i18n": "/quartz-i18n/static-1.1229",
  "quartz-routing": "/quartz-routing/static-1.984",
  "quartz-test": "/quartz-test/static-1.1229",
  "quartz-tracking": "/quartz-tracking/static-1.933",
  "trellis-components": "/trellis-components/static-1.2882",
  "ui-fonts": "/ui-fonts/static-1.1137",
  "usage-tracker-container": "/usage-tracker-container/static-1.7688",
  "usage-tracker-core": "/usage-tracker-core/static-1.7548",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.275",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8568",
  "sanitize-text": "/sanitize-text/static-1.8544",
  "PatternValidationJS": "/PatternValidationJS/static-1.3275",
  "ReduxMessenger": "/ReduxMessenger/static-2.10757",
  "outpost": "/outpost/static-1.4524",
  "rpc-client-utils": "/rpc-client-utils/static-1.5051",
  "sanitize": "/sanitize/static-1.4857",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4882",
  "floating-ui": "/floating-ui/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9810",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.86",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2863",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3347",
  "foundations-theming-base": "/foundations-theming-base/static-1.3849",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.347",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9872",
  "atom": "/atom/static-1.5466",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8302",
  "ContentUtils": "/ContentUtils/static-1.69289",
  "data-token-picker": "/data-token-picker/static-1.16997",
  "file-manager-components": "/file-manager-components/static-1.24664",
  "FileManagerCore": "/FileManagerCore/static-1.40163",
  "FileManagerLib": "/FileManagerLib/static-1.40304",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8307",
  "hub-http-contrib": "/hub-http-contrib/static-1.3412",
  "interframe": "/interframe/static-3.5128",
  "layout-dnd-components": "/layout-dnd-components/static-1.13084",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12059",
  "property-translator": "/property-translator/static-1.5766",
  "react-codemirror": "/react-codemirror/static-1.11027",
  "react-colorpicker": "/react-colorpicker/static-2.10599",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8488",
  "rich-text-lib": "/rich-text-lib/static-1.20423",
  "tinymce-data": "/tinymce-data/static-1.41331",
  "tinymce-themes": "/tinymce-themes/static-1.57216",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10255",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5589",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16726",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.90",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10750",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10748",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5384",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1363",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.461",
  "chirp-fetch": "/chirp-fetch/static-1.2286",
  "stylex-utils": "/stylex-utils/static-1.155",
  "chatspot-core": "/chatspot-core/static-1.23360",
  "copilot-toolkit": "/copilot-toolkit/static-1.11984",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13416",
  "data-fetching-client": "/data-fetching-client/static-1.10033",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5146",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29449",
  "usage-tracker": "/usage-tracker/static-1.7698",
  "cms-field-types": "/cms-field-types/static-1.5197",
  "content-icons-ui": "/content-icons-ui/static-1.2412",
  "integrations-lib": "/integrations-lib/static-1.17229",
  "customer-data-objects": "/customer-data-objects/static-1.8077",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1939",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5013",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4530",
  "poll-commands": "/poll-commands/static-1.3858",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9463",
  "video-components-external": "/video-components-external/static-1.12284",
  "video-data-lib": "/video-data-lib/static-1.35942",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.590",
  "audio-components": "/audio-components/static-1.6450",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29922",
  "FileManagerImages": "/FileManagerImages/static-1.37815",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1638",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.648",
  "ui-universal-auth": "/ui-universal-auth/static-1.9557",
  "urlinator": "/urlinator/static-1.4904",
  "video-components": "/video-components/static-1.14286",
  "video-embed": "/video-embed/static-1.36776",
  "ts-schema": "/ts-schema/static-1.4346",
  "ContentData": "/ContentData/static-1.69364",
  "layout-data-lib": "/layout-data-lib/static-1.10384",
  "react-dnd-compat": "/react-dnd-compat/static-1.5000",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1932",
  "external-options-client-types": "/external-options-client-types/static-1.4393",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7281",
  "hs-promise-utils": "/hs-promise-utils/static-1.5975",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4095",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9311",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3450",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11535",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5823",
  "magpie-types": "/magpie-types/static-1.5283",
  "simple-logging-lib": "/simple-logging-lib/static-1.3439",
  "avatar-components": "/avatar-components/static-1.2868",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10217",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6971",
  "flux-actions": "/flux-actions/static-1.377",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5261",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14644",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5997",
  "laboratory-lib": "/laboratory-lib/static-3.7537",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8150",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10657",
  "unified-auth": "/unified-auth/static-1.1071",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.917",
  "breeze-engine-core": "/breeze-engine-core/static-1.1217",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1019",
  "navigation-messaging": "/navigation-messaging/static-1.8304",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13411",
  "content-media-compositions": "/content-media-compositions/static-2.17418",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19514",
  "nudge-client-utils": "/nudge-client-utils/static-1.3264",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1353",
  "social-insights-client-types": "/social-insights-client-types/static-1.22776",
  "advanced-menus-core": "/advanced-menus-core/static-1.15680",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12508",
  "ExportDialog": "/ExportDialog/static-6.10764",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34983",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4068",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4398",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.400",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4273",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7186",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3724",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3962",
  "persist-promise": "/persist-promise/static-1.4089",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6096",
  "reactive-lib": "/reactive-lib/static-1.1107",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.720",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3396",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.611",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1649",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.121",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1174",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.326",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.672",
  "slack-ui-library": "/slack-ui-library/static-1.10783",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.522",
  "event-emitter": "/event-emitter/static-1.1345",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3021",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3340",
  "onboarding-tours": "/onboarding-tours/static-1.17254",
  "whisper-core-api": "/whisper-core-api/static-1.7477",
  "fsm": "/fsm/static-1.4139",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15679",
  "simple-menus-lib": "/simple-menus-lib/static-1.17196",
  "settings-ui-lib": "/settings-ui-lib/static-1.12911",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3821",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10254",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19395",
  "growth-data-modal": "/growth-data-modal/static-1.6002",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2831",
  "navigation-components": "/navigation-components/static-1.18977",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5469",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1321",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8038",
  "user-context": "/user-context/static-1.5473",
  "react-flip-move": "/react-flip-move/static-1.81",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2680",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2859",
  "user-context-client": "/user-context-client/static-1.4895",
  "nest": "/nest/static-1.621",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18513",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15693",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8000",
  "onboarding-scopes": "/onboarding-scopes/static-1.6839"
}
};
